// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 188 ? "Body-Body" : chunkId) + "." + {"188":"67de135aee0eb0d368f8","209":"06704794775454e4f6a4"}[chunkId] + ".bundle.js";
};